<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <b-container class="container">
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">重置密码</h1>
              <p class="text-lead text-white">忘记密码时，可在此通过手机号重置密码</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
          xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--9 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col lg="6" md="8">
          <b-card no-body class="bg-secondary border-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <div style="display: flex;width: 100%;">
                    <div style="float: left;width: 54%;">
                      <base-input alternative class="mb-3" prepend-icon="ni ni-mobile-button" placeholder="手机号"
                        name="Name" v-model="model.loginName">
                      </base-input>
                    </div>
                    <div style="float: right;width: 45%;">
                      <b-button v-show="show" @click="sendSms()" style="margin-left: 5px; width: 100%;">获取验证码
                      </b-button>
                      <b-button v-show="!show" style="margin-left: 5px; width: 100%;">{{count}}s</b-button>
                    </div>
                  </div>

                  <base-input alternative class="mb-3" prepend-icon="ni ni-chat-round" placeholder="输入验证码" name="code"
                    v-model="model.code">
                  </base-input>

                  <base-input alternative class="mb-3" prepend-icon="ni ni-lock-circle-open" placeholder="请设置密码"
                    type="password" name="Password" v-model="model.password">
                  </base-input>

                  <base-input alternative class="mb-3" prepend-icon="ni ni-lock-circle-open" placeholder="请重新输入密码"
                    type="password" name="Password" v-model="model.twoPassword">
                  </base-input>

                  <div class="text-center">
                    <b-button type="submit" variant="primary">确认重置</b-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-3">
            <b-col cols="6">
              <!-- <router-link to="/dashboard" class="text-light"><small>忘记密码?</small></router-link> -->
            </b-col>
            <b-col cols="6" class="text-right">
              <router-link to="/login" class="text-light"><small>去登陆</small></router-link>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
  import {
    retrieveCode,
    retrievePassword
  } from "../../api/user.js";
  import {
    Message
  } from 'element-ui'
  export default {
    components: {
      [Message.name]: Message
    },
    name: 'register',
    data() {
      return {
        model: {
          loginName: '',
          code: '',
          password: '',
          twoPassword: ''
        },
        count: 0,
        timer: null,
        show: true
      }
    },
    methods: {
      onSubmit() {
        var that = this;
        // 校验验证码不能为空
        if (that.model.code == null || that.model.code == "") {
          Message.info("验证码为空");
          return;
        }

        if (that.model.password == null || that.model.password == "") {
          Message.info("密码为空");
          return;
        }

        // 校验密码输入是否一致
        if (that.model.password != that.model.twoPassword) {
          Message.info("两次密码输入不一致");
          return;
        }

        if (that.model.loginName == null || that.model.loginName == "") {
          Message.info("手机号不正确");
          return;
        }

        retrievePassword(that.model.loginName, that.model.password, that.model.code).then(res => {
          if (res.data.code != 1) {
            Message.info(res.data.message);
          } else {
            Message.info("重置成功，请登录");
          }
        }).catch((err) => {
          console.log(err)
        })
      },
      sendSms() {
        var that = this;
        if (that.model.loginName == null || that.model.loginName == "") {
          Message.info("手机号为空");
          return;
        }

        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000)
        }
        // 发送验证码
        retrieveCode(that.model.loginName).then(res => {
          if (res.data.code != 1) {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
            Message.info(res.data.message);
          } else {
            Message.info("短信发送成功,请查收");
          }
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  };
</script>
<style></style>
